import React from "react";

export const simCount = (u, key) => Number((key === "italiamobile" ? u?.sim_stock : u?.sim_stocks?.[key]) || 0);

export const simOperators = (items) => {
  const ops = (items || []).filter((o) => o.kind === "sim" && o.active);
  return ops.length ? ops : [{ key: "italiamobile", name: "Italia Mobile" }];
};

export const DealerSimCounts = ({ u, ops }) => (
  <div data-testid={`account-sim-${u.id}`}>
    {ops.map((o) => {
      const n = simCount(u, o.key);
      return <p key={o.key} className={`text-xs font-sans ${n > 0 ? "text-emerald-500" : "text-muted-foreground"}`} data-testid={`account-sim-${u.id}-${o.key}`}>SIM {o.name}: {n}</p>;
    })}
  </div>
);
